import type { EditorPlugin } from './../../ricos-types';
import { RESOLVERS_IDS } from './../../toolbars-v3/lib/resolvers-ids';

import { TEXT_BUTTON_REDO, TEXT_BUTTON_UNDO } from './data-hooks';
import { undoRedo } from './history';
import RedoIcon from './RedoIcon';
import UndoIcon from './UndoIcon';

export const pluginUndoRedo: EditorPlugin = {
  config: {},
  type: 'undo-redo',
  tiptapExtensions: [undoRedo],
  textButtons: [
    {
      id: 'UNDO',
      type: 'toggle',
      presentation: {
        dataHook: TEXT_BUTTON_UNDO,
        tooltip: 'UndoButton_Tooltip',
        icon: UndoIcon,
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        disabled: RESOLVERS_IDS.IS_UNDO_STACK_EMPTY,
      },
      command:
        ({ publicCommands }) =>
        () => {
          publicCommands.undo();
          return true;
        },
    },
    {
      id: 'REDO',
      type: 'toggle',
      presentation: {
        dataHook: TEXT_BUTTON_REDO,
        tooltip: 'RedoButton_Tooltip',
        icon: RedoIcon,
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        disabled: RESOLVERS_IDS.IS_REDO_STACK_EMPTY,
      },
      command:
        ({ publicCommands }) =>
        () => {
          publicCommands.redo();
          return true;
        },
    },
  ],
};
